module.exports = __webpack_public_path__ + "416f9972850891f4a03e56c0f37acff5.png";